import { API_BASE_URL } from '../../utlis';
import { AuthenticationAPI } from './Authentication';

interface FetchOptions {
	method: string;
	endpoint: string;
	data?: any;
	headers?: Record<string, string>;
}
interface FetchOptionsForm {
	method: string;
	endpoint: string;
	body?: any;
	headers?: Record<string, string>;
}

const fetchHandler = async ({ method, endpoint, data }: FetchOptions) => {
	// const API_BASE_URLS = `${process.env.REACT_APP_API_URL}${endpoint}`;
	const API_BASE_URLS = `${API_BASE_URL}${endpoint}`;
	const headers: HeadersInit = {
		'Content-Type': 'application/json',
	};
	const accessToken = localStorage.getItem('token');
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	const options: RequestInit = {
		method,
		headers,
		cache: 'no-cache',
		credentials: 'same-origin',
	};

	if (method !== 'GET' && data) {
		options.body = JSON.stringify(data);
	}

	try {
		const response = await fetch(API_BASE_URLS, options);

		if (response.status === 401) {
			let unauthorizedErrorCount = parseInt(
				localStorage.getItem('unauthorizedErrorCount') || '0',
				10
			);
			unauthorizedErrorCount++;
			localStorage.setItem('unauthorizedErrorCount', unauthorizedErrorCount.toString());

			if (unauthorizedErrorCount >= 2) {
				await AuthenticationAPI.Logout(); // Ensure logout API is invoked
				localStorage.removeItem('unauthorizedErrorCount'); // Reset counter
			}
		} else {
			localStorage.removeItem('unauthorizedErrorCount'); // Reset counter on non-401 responses
		}

		if (response.ok) {
			const result = await response.json();
			return result;
		} else {
			const result = await response.json();
			return { isError: true, data: result };
		}
	} catch (error) {
		console.error('Fetch error:', error);
		return {
			isError: true,
			data: "We can't process your request at this time. Please try later.",
		};
	}
};

export default fetchHandler;

export const fetchHandler2 = async ({ method, endpoint, data }: FetchOptions) => {
	const API_BASE_URLS = `${process.env.REACT_APP_API_URL}${endpoint}`;
	const headers: HeadersInit = {
		'Content-Type': 'application/json',
	};
	const accessToken = localStorage.getItem('token');
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	const options: RequestInit = {
		method,
		headers,
		cache: 'no-cache',
		credentials: 'same-origin',
	};

	if (method !== 'GET' && data) {
		options.body = JSON.stringify(data);
	}

	try {
		const response = await fetch(API_BASE_URLS, options);

		if (response.status === 401) {
			let unauthorizedErrorCount = parseInt(
				localStorage.getItem('unauthorizedErrorCount') || '0',
				10
			);
			unauthorizedErrorCount++;
			localStorage.setItem('unauthorizedErrorCount', unauthorizedErrorCount.toString());

			if (unauthorizedErrorCount >= 2) {
				await AuthenticationAPI.Logout(); // Ensure logout API is invoked
				localStorage.removeItem('unauthorizedErrorCount'); // Reset counter
			}
		} else {
			localStorage.removeItem('unauthorizedErrorCount'); // Reset counter on non-401 responses
		}

		if (response.ok) {
			const result = await response.json();
			return result;
		} else {
			const result = await response.json();
			return { isError: true, data: result };
		}
	} catch (error) {
		console.error('Fetch error:', error);
		return {
			isError: true,
			data: "We can't process your request at this time. Please try later.",
		};
	}
};

export const fetchHandlerForm = async ({ method, endpoint, body }: FetchOptionsForm) => {
	// const API_BASE_URLS = `${process.env.REACT_APP_API_URL}${endpoint}`;
	const API_BASE_URLS = `${API_BASE_URL}${endpoint}`;
	const headers: HeadersInit = {};

	const accessToken = localStorage.getItem('token');
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	const options: RequestInit = {
		method,
		headers,
		cache: 'no-cache',
		credentials: 'same-origin',
	};

	if (method !== 'GET' && body) {
		options.body = body;
	}

	try {
		const response = await fetch(API_BASE_URLS, options);

		if (response.status === 401) {
			let unauthorizedErrorCount = parseInt(
				localStorage.getItem('unauthorizedErrorCount') || '0',
				10
			);
			unauthorizedErrorCount++;
			localStorage.setItem('unauthorizedErrorCount', unauthorizedErrorCount.toString());

			if (unauthorizedErrorCount >= 2) {
				await AuthenticationAPI.Logout(); // Ensure logout API is invoked
				localStorage.removeItem('unauthorizedErrorCount'); // Reset counter
			}
		} else {
			localStorage.removeItem('unauthorizedErrorCount'); // Reset counter on non-401 responses
		}

		if (response.ok) {
			const result = await response.json();
			return result;
		} else {
			const result = await response.json();
			return { isError: true, data: result };
		}
	} catch (error) {
		console.error('Fetch error:', error);
		return {
			isError: true,
			data: "We can't process your request at this time. Please try later.",
		};
	}
};
